import moment from 'moment';

export const getMinDatePicker = (): Date =>
  moment().subtract(30, 'days').startOf('day').toDate();
